<template>
  <div class="xero-wrap xero-wrap-mobile">
    <div class="logo"></div>
    <div class="clear">
      <div class="back_box" @click="prev">
        <i class="el-icon-back"></i> Back
      </div>
      <div class="pro">
        <div class="tit">2 / 2</div>
        <el-progress :percentage="100"></el-progress>
      </div>
    </div>
    <div class="title">Register Peiso</div>
    <div class="bgd">
      <div class="con">
        <h1 style="margin-bottom: 50px">Payment Method</h1>

        <h2>Discount Code</h2>
        <div class="singleItem">
          <div class="inputItem discount">
            <input type="text" :class="{ 'border-error': isErrorDiscount }" v-model="discountCode"
              @input="debounceDiscountCode" />
          </div>
        </div>

        <h2><i style="font-style: normal; color: red">*</i>Card Number</h2>
        <div class="inputItem">
          <input :class="{ 'border-error': validationInputError['card'] }" @blur="validateInput('card')" type="text"
            v-model="card" maxlength="16" @input="validate('card')" :disabled="isDisableCards" />
        </div>
        <h2><i style="font-style: normal; color: red">*</i>Full Name</h2>
        <div class="inputItem">
          <input :class="{ 'border-error': validationInputError['full'] }" @blur="validateInput('full')" type="text"
            v-model="full" maxlength="40" @input="validateComplete" :disabled="isDisableCards" />
        </div>
        <div class="doubleInputItem clear">
          <div class="singleItem">
            <h2><i style="font-style: normal; color: red">*</i>Expiry Date</h2>
            <div class="inputItem" :class="{
              'border-error':
                validationInputError['expirem'] ||
                validationInputError['expirey'],
            }" style="
                border: 1px solid var(--background-color-4);
                box-sizing: border-box;
                background: var(--background-color-3);
              ">
              <input @blur="validateInput('expirem')" type="text" ref="month" v-model="expirem" style="
                  border: none;
                  width: 150px;
                  padding: 0 0 0 15px;
                  text-align: right;
                " maxlength="2" @input="validate('expirem')" :disabled="isDisableCards" />
              /
              <input @blur="validateInput('expirey')" type="text" ref="year" @keyup="nextFocus1($event)"
                v-model="expirey" style="border: none; width: 150px; padding: 0" maxlength="2"
                @input="validate('expirey')" :disabled="isDisableCards" />
            </div>
          </div>
          <div class="singleItem">
            <h2 style="letter-spacing: 3px">
              <i style="font-style: normal; color: red">*</i>CVV
            </h2>
            <div class="inputItem">
              <input :class="{ 'border-error': validationInputError['cvv'] }" @blur="validateInput('cvv')" type="text"
                v-model="cvv" maxlength="4" @input="validate('cvv')" :disabled="isDisableCards" />
            </div>
          </div>
        </div>

        <div class="btm-btns clear">
          <button class="next" :class="{ disabled: !isComplete }" :disabled="!isComplete" @click="confirm">
            Create Venue
          </button>
        </div>
      </div>
    </div>

    <el-dialog title="" :visible.sync="loading" :modal-append-to-body="false" :show-close="false"
      class="modalMessageLoading">
      <modal-message-dialog :isLoading="loading" :isDoneLoading="doneLoading" :label="messageLabel"
        :subLabel="messageSubLabel" @hide-message="doneLoading()"></modal-message-dialog>
    </el-dialog>

    <el-dialog class="peiso-modal policies" :visible.sync="isOpenTermsCondition" :modal-append-to-body="false" :show-close="false" :close-on-click-modal='false' :close-on-press-escape="false" width="">
      <modal-terms-and-condition></modal-terms-and-condition>
      <template #footer>
          <div class="d-flex justify-content-end m-top-1rem">
              <el-button type="peiso-primary-pink-border-only" @click="isOpenPolicy = true, isOpenTermsCondition = false">Next &gt;&gt;</el-button>
          </div>
      </template>
    </el-dialog>

    <!-- <el-dialog class="peiso-modal policies" :visible.sync="isOpenTermsCondition2" :modal-append-to-body="false" :show-close="false" :close-on-click-modal='false' :close-on-press-escape="false" width="">
       <modal-terms></modal-terms>
      <template #footer>
          <div class="d-flex justify-content-between m-top-1rem">
            <el-button type="peiso-primary-pink-border-only" @click="isOpenTermsCondition2 = false, isOpenTermsCondition = true">&lt;&lt; Prev</el-button>
            <el-button type="peiso-primary-pink-border-only" @click="isOpenTermsCondition2 = false, isOpenPolicy = true">Next &gt;&gt;</el-button>
          </div>
      </template>
    </el-dialog> -->

    <el-dialog class="peiso-modal policies" :visible.sync="isOpenPolicy" :modal-append-to-body="false" :show-close="false" :close-on-click-modal='false' :close-on-press-escape="false" width="">
      <modal-policies @cookies-policy="isOpenCookie = true" @gpdr="isOpenGdpr = true"></modal-policies>
      <template #footer>
          <div class="d-flex justify-content-end m-top-1rem">
            <!-- <el-button type="peiso-primary-pink-border-only" @click="isOpenPolicy = false, isOpenTermsCondition = true">&lt;&lt; Prev</el-button> -->
            <el-button type="peiso-primary-pink-border-only" @click="isOpenPolicy = false">Accept</el-button>
          </div>
      </template>
    </el-dialog>

    <el-dialog class="peiso-modal policies" :visible.sync="isOpenGdpr" :modal-append-to-body="false" :show-close="false" :close-on-click-modal='false' width="">
      <modal-gdpr-privacy></modal-gdpr-privacy>
      <template #footer>
          <div class="d-flex justify-content-between m-top-1rem">
            <el-button type="peiso-primary-pink-border-only" @click="isOpenGdpr = false">&lt;&lt; Back</el-button>
            <!-- <el-button type="peiso-primary-pink-border-only" @click="isOpenGdpr = false, isOpenCookie = true">Next &gt;&gt;</el-button> -->
          </div>
      </template>
    </el-dialog>

    <el-dialog class="peiso-modal policies" :visible.sync="isOpenCookie" :modal-append-to-body="false" :show-close="false" :close-on-click-modal='false' width="">
      <modal-cookie-policy></modal-cookie-policy>
      <template #footer>
          <div class="d-flex justify-content-between m-top-1rem">
            <el-button type="peiso-primary-pink-border-only" @click="isOpenCookie = false">&lt;&lt; Back</el-button>
              <!-- <el-button type="peiso-primary-pink-border-only" @click="isOpenCookie = false">Accept</el-button> -->
          </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import api from "../../api/xero";
import login from "@/api/login";
import account from "@/api/api";
import modalMessageDialog from "../modal/messageDialog.vue";
import modalPolicies from "@/components/modal/policies.vue";
import modalTermsAndCondition from "@/components/modal/termsAndCondition.vue";
import modalGdprPrivacy from "@/components/modal/gdprPrivacy.vue";
import modalCookiePolicy from "@/components/modal/cookiePolicy.vue";
import modalTerms from "@/components/dashboard/component/terms.vue";

import _ from "lodash";
import discount from "@/api/discount";
export default {
  components: { modalMessageDialog, 
    modalPolicies: modalPolicies, 
    modalTermsAndCondition: modalTermsAndCondition, 
    modalGdprPrivacy: modalGdprPrivacy, 
    modalCookiePolicy: modalCookiePolicy,
    modalTerms: modalTerms},
  data() {
    return {
      card: "",
      full: "",
      expirem: "",
      expirey: "",
      cvv: "",
      // 是否输入完整
      isComplete: false,
      isCardFormRight: true,
      validationInputError: {
        card: false,
        full: false,
        expirem: false,
        expirey: false,
        cvv: false,
      },
      loading: false,
      doneLoading: true,
      messageLabel: "Loading...",
      messageSubLabel:
        "Please wait as this process will take some time to complete.",
      discountCode: "",
      isInputDiscount: false,
      isErrorDiscount: false,
      selectedDiscount: {},
      subscriptionPrice: 149,
      subscriptionDiscount: 0,
      subscriptionDisplay: "",
      subscriptionGST: 0.1,
      isDisableCards: false,
      isOpenPolicy: false,
      isUserAgreement: false,
      isOpenTermsCondition: false,
      isOpenGdpr: false,
      isOpenCookie: false,
      isOpenTermsCondition2: false,
    };
  },
  created() {
    this.isOpenTermsCondition = true
    if (!sessionStorage.getItem("request_params")) {
      this.$router.replace("/welcome");
    } else {
      var register = JSON.parse(sessionStorage.getItem("request_params"));
      if (register.isPro) {
        this.subscriptionPrice = 299;
      }
    }
  },
  computed: {
    totalPaymentAmount() {
      var total = this.subscriptionPrice - this.subscriptionDiscount;
      var tax = total * this.subscriptionGST;

      return total + tax;
    },
  },
  methods: {
    validateInput(modelName) {
      const model =
        typeof this[modelName] === "number"
          ? JSON.stringify(this[modelName])
          : this[modelName];
      if (model.replace(/\s+/g, "") === "") {
        this.validationInputError[modelName] = true;
      } else {
        this.validationInputError[modelName] = false;
      }
    },
    nextFocus1(el) {
      if (el.keyCode == 8 && this.expirey == "") this.$refs.month.focus();
    },
    validate(type) {
      var that = this;
      if (type === "card" || type === "cvv") {
        let card = that.card.replace(/[^\d.]/g, "");
        let cvv = that.cvv;
        if (
          (card.length === 15 && cvv.length === 4) ||
          (card.length === 16 && cvv.length === 3)
        ) {
          this.isCardFormRight = true;
        } else if (card.length > 0 && cvv.length > 0) {
          this.isCardFormRight = false;
          // Utils.alert2('', 'Please enter the correct credit card format', 'error')
        } else if (card.length === 0 && cvv.length === 0) {
          this.isCardFormRight = true;
        } else {
          this.isCardFormRight = false;
        }
      }
      if (type === "card") {
        that.card = that.card.replace(/[^\d]/g, "");
      } else if (type === "cvv") {
        that.cvv = that.cvv.replace(/[^\d]/g, "");
      } else if (type === "expirem") {
        that.expirem = that.expirem.replace(/[^\d]/g, "");
        if (parseInt(that.expirem) > 12) {
          that.expirem = that.expirem.slice(0, 1);
        } else {
          if (that.expirem.length === 2) that.$refs.year.focus();
        }
      } else if (type === "expirey") {
        that.expirey = that.expirey.replace(/[^\d]/g, "");
      }
      that.validateComplete();
    },
    validateComplete() {
      var that = this;
      if (
        that.card.replace(/\s+/g, "") !== "" &&
        that.full.replace(/\s+/g, "") !== "" &&
        that.expirem.replace(/\s+/g, "") !== "" &&
        that.expirey.replace(/\s+/g, "") !== "" &&
        that.cvv.replace(/\s+/g, "") !== ""
      ) {
        that.isComplete = true;
      } else {
        that.isComplete = false;
      }
    },
    async confirm() {
      if (this.isErrorDiscount) {
        Utils.alert2(
          "",
          "Discount code is invalid, please try again...",
          "error"
        );
        return;
      }
      if (!this.isCardFormRight && !this.isDisableCards) {
        Utils.alert2(
          "",
          "Please enter the correct credit card format",
          "error"
        );
        return;
      }

      let request_params = JSON.parse(sessionStorage.getItem("request_params"));

      request_params.cardName = this.full === "" ? null : this.full;
      request_params.cardNumber = this.card === "" ? null : this.card;
      request_params.cvv = this.cvv === "" ? null : this.cvv;
      request_params.expire =
        this.expirem !== "" && this.expirey !== ""
          ? this.expirem + "/" + this.expirey
          : null;
      request_params.discountCode = this.discountCode;
      request_params.monthlyFee = this.totalPaymentAmount;

      this.loading = true;
      this.doneLoading = false;
      api.signUpWithXero({
        params: request_params,
        callback: async (res) => {
          if (res.data.code == 0) {
            // this.$router.replace('/success')
            let user = {
              userName: request_params.userName,
              password: request_params.password,
            };
            login.login(user, async (res) => {
              var data = res.data.data;
              if (res.data.code == 0) {
                window.sessionStorage.setItem("token", data.token);
                sessionStorage.setItem("venueType", 1);
                sessionStorage.setItem("isPinNeeded", 1);
                sessionStorage.setItem("isSingleAccount", 1);
                sessionStorage.setItem("subVenueId", data.venueId);
                sessionStorage.setItem("subVenueName", data.venueName);

                if (request_params.mobileLists) {
                  for (var i = 0; i < request_params.mobileLists.length; i++) {
                    var mobile = request_params.mobileLists[i];
                    var params = {
                      fullName: mobile.name,
                      mobileNumber: mobile.mobile,
                      emailAddress: mobile.emailAddress,
                    };
                    await api.signUpaccountAddApi(params);

                    this.messageSubLabel = `Adding ${i + 1} out of ${request_params.mobileLists.length
                      } app accounts listed<br>Please wait as this process will take some time to complete.`;
                  }
                }
                const isPro = request_params.isPro;
                sessionStorage.removeItem("request_params");

                if (isPro == true) {
                  // this.$router.replace("/success");
                  window.location.href = `${process.env.WEB_URL}/peiso-pro-thank-you-page`;
                } else {
                  window.location.href = `${process.env.WEB_URL}/peiso-lite-thank-you-page`;
                }

                this.loading = false;
                this.doneLoading = true;
                // this.$router.replace('/success')
              }
            });
          } else {
            Utils.alert2("", res.data.message, "error");
            this.loading = false;
            this.doneLoading = true;
          }
        },
      });
    },
    prev() {
      this.$router.replace("/mobileApp");
    },

    inputDiscount() {
      this.isInputDiscount = true;
    },

    debounceDiscountCode: _.debounce(async function (e) {
      this.subscriptionDisplay = "";
      this.subscriptionDiscount = 0;
      this.isDisableCards = false;

      if (e.target.value == "") {
        this.isErrorDiscount = false;
        return;
      }

      this.isErrorDiscount = true;
      var payloads = {
        code: e.target.value,
      };
      const res = await discount.getDiscount(payloads);
      if (res.data.code != 0) {
        this.isErrorDiscount = true;
        return;
      }

      var data = res.data.data;
      if (data.length) {
        this.isErrorDiscount = false;
        this.selectedDiscount = data[0];
        this.isComplete = true;
        if (data[0].type == "fixed" || data[0].type == "trial") {
          this.subscriptionDiscount = this.selectedDiscount.value;
          this.subscriptionDisplay = this.selectedDiscount.remarks
            ? `(${this.selectedDiscount.remarks})`
            : `(CODE: ${this.selectedDiscount.code})`;
        } else {
          this.subscriptionDiscount =
            this.subscriptionPrice * (this.selectedDiscount.value / 100);
          this.subscriptionDisplay = `( ${this.selectedDiscount.value}% - ${this.selectedDiscount.remarks
              ? `${this.selectedDiscount.remarks}`
              : `CODE: ${this.selectedDiscount.code}`
            })`;
        }
        // this.isDisableCards = true
      }
    }, 500),
  },
};
</script>

<style lang="scss" scoped>
@import "static/scss/colors";
@import "static/scss/fonts/fonts";

.xero-wrap {
  color: var(--text-color);
  padding-bottom: 50px;
  min-width: 1200px;

  .bgd {
    width: 100%;
    background: var(--background-color-4);
    padding: 50px 0 65px 0;

    //margin-bottom: 50px;
    .con {
      width: 740px;
      margin: 0 auto;

      .btm-btns {
        width: 100%;
        margin: 0 auto;

        button {
          width: 280px;
          height: 60px;
          background: var(--background-color-3);
          float: left;
          box-sizing: border-box;
          font-size: 26px;
          cursor: pointer;
        }

        .next {
          margin-right: 50px;
          border: 2px solid #ea3796;
          font-weight: 700;
          color: #ea3796;
        }

        .disabled {
          border: 2px solid #8e3771;
          color: #8e3771;
          cursor: not-allowed;
        }
      }

      h1 {
        font-size: 30px;
        line-height: 42px;
        margin-bottom: 10px;
        text-align: center;
      }

      .subtitle {
        font-size: 20px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: var(--text-color);
        line-height: 28px;
        margin-bottom: 50px;
        text-align: center;
      }

      h2 {
        font-size: 14px;
        line-height: 16px;
        margin-bottom: 10px;
      }

      .inputItem {
        width: 100%;
        margin-bottom: 30px;
        position: relative;

        input {
          outline: none;
          border: 1px solid rgba(95, 95, 95, 1);
          background: var(--background-color-3);
          width: 100%;
          box-sizing: border-box;
          padding: 0 15px;
          font-family: "SFProText-Regular";
          font-size: 20px;
          color: var(--text-color);
          height: 50px;
        }

        .lft {
          position: absolute;
          left: 20px;
          line-height: 50px;
          color: var(--text-color);
        }

        .rgt {
          position: absolute;
          right: 20px;
          line-height: 50px;
          color: var(--text-color);
        }
      }

      .singleItem {
        width: 355px;
      }

      .singleItem:nth-child(1) {
        float: left;
      }

      .singleItem:nth-child(2) {
        float: right;
      }
    }
  }

  .subscription-details-container {
    min-height: 210px;
    max-width: 450px;
    width: 100%;
    border-radius: 5px;
    background-color: $black2;
    margin: 0 auto 2rem;
    padding: 24px;
    font-family: "Montserrat", sans-serif;
    gap: 1rem;

    .details-header {
      font-size: 20px;
      font-weight: 700;
    }

    .details-content {
      gap: 12px;

      .separator {
        padding-bottom: 1px;
        border-bottom: 1px solid $gray8;
      }

      .details-name {
        max-width: 230px;
      }

      .details-amount {
        text-wrap: nowrap;

        &.total {
          font-size: 20px;
          font-weight: 700;
        }
      }
    }
  }
}

.pro {
  margin-bottom: 30px;
  width: 200px;
  float: right;

  .tit {
    text-align: right;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ea3796;
    line-height: 22px;
  }
}

.title {
  font-size: 24px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: var(--text-color);
  line-height: 33px;
  margin-bottom: 39px;
}

.back_box {
  float: left;
  width: 150px;
  font-size: 14px;
  font-weight: 600;
  color: var(--text-color);
  line-height: 20px;
  cursor: pointer;

  .el-icon-back {
    margin-right: 10px;
    font-size: 20px;
    position: relative;
    top: 3px;
  }
}

.border-error {
  border-color: #f20014 !important;
}

</style>



// WEBPACK FOOTER //
// src/components/register/pay.vue